"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = ({
  className
}) => {
  return _react.default.createElement(_SvgIcon.default, {
    className: className
  }, _react.default.createElement("path", {
    d: "M1.29938 17.977C0.505839 19.3102 1.46651 21 3.01797 21H20.982C22.5335 21 23.4942 19.3102 22.7006 17.977L13.7186 2.88722C12.9432 1.58451 11.0568 1.58451 10.2814 2.88722L1.29938 17.977Z",
    fill: "#EB5757"
  }), _react.default.createElement("path", {
    d: "M15.0833 18V17.064H12.8273V9.65997H11.8433L9.53928 11.088V12.18L11.7953 10.824V17.064H9.52728V18H15.0833Z",
    fill: "white"
  }));
};

exports.default = _default;
module.exports = exports.default;